import React from "react";
import StatCard from "./StatCard";

const formatDurationSeconds = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.round((seconds % 3600) / 60);
  if (hrs === 0) return `${mins}m`;
  return `${hrs}h ${mins}m`;
};

const ratio = (numerator, denominator) => (denominator > 0 ? `${numerator} / ${denominator}` : `${numerator} / 0`);

const PerformanceSummaryCards = ({ summary, loading, error }) => {
  if (error) {
    return <div className="dash-section-error">Couldn't load performance summary: {error}</div>;
  }

  return (
    <div className="dash-numbers-grid perf-summary-grid">
      <StatCard
        label="Notes completed"
        displayValue={loading ? undefined : ratio(summary?.notesCompleted ?? 0, summary?.notesTotal ?? 0)}
        loading={loading}
      />
      <StatCard
        label="Questions completed"
        displayValue={loading ? undefined : ratio(summary?.questionsCompleted ?? 0, summary?.questionsTotal ?? 0)}
        loading={loading}
      />
      <StatCard
        label="Correct answers"
        displayValue={loading ? undefined : ratio(summary?.correctAnswered ?? 0, summary?.totalAnswered ?? 0)}
        loading={loading}
      />
      <StatCard
        label="Wrong answers"
        displayValue={loading ? undefined : ratio(summary?.wrongAnswered ?? 0, summary?.totalAnswered ?? 0)}
        loading={loading}
      />
      <StatCard
        label="Hours spent on app"
        displayValue={loading ? undefined : formatDurationSeconds(summary?.appUsageSeconds)}
        loading={loading}
      />
    </div>
  );
};

export default PerformanceSummaryCards;
